import { ComparisonPage } from "@/pages/dashboard/comparison/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/dashboard/compare")({
    component: ComparisonPage,
});
